// extracted by mini-css-extract-plugin
module.exports = {"Video":"_17KCH","Video_responsive":"j6CKJ","Video_isInteractive":"p7TAa","Video__Preview":"KpRpH","Video__Button":"sq9Bj","Video__ButtonIcon":"xkMGH"};